import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getChatThrottled } from 'app/modules';
import Header from 'presentation/components/Header.jsx';
import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/ChatClosed.css';

const ChatThrottled = ({ message, title }) => {
  ChatThrottled.propTypes = {
    message: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };

  return (
    <div className={styles.chatClosed} data-aid="gladlyChatClosedPane">
      <Header title={title} />
      <Wrapper className={styles.chatClosed_body}>{message}</Wrapper>
    </div>
  );
};

const Wrapper = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.primary};
`;

export { ChatThrottled };

export const mapStateToProps = (state, props) => {
  const chatThrottled = getChatThrottled(state);
  return {
    ...props,
    message: chatThrottled.message,
    title: chatThrottled.title,
  };
};

const ChatThrottledContainer = connect(mapStateToProps)(ChatThrottled);
export default ChatThrottledContainer;
